import { EMPTY_CHARACTER } from "@pulse/shared-components";

/**
 * Normalizes RTE (Rich Text Editor) HTML values by replacing empty heading or paragraph tags
 * with a empty character.
 *
 * This function checks if value has only whitespace between the tags (`<h1>`-`<h6>`, `<p>`).
 * If matched, it returns `EMPTY_CHARACTER`. Else, it returns the original value unchanged.
 *
 * @param value - The HTML string to evaluate.
 * @returns {string} Returns `EMPTY_CHARACTER` if the input is an empty heading or paragraph tag;
 * otherwise, returns the original input string.
 *
 * @example
 * formatRTEHtmlValue("<h2></h2>") // returns EMPTY_CHARACTER
 * formatRTEHtmlValue("<h2>   </h2>") // returns EMPTY_CHARACTER
 * formatRTEHtmlValue("<h2>Content</h2>") // returns "<h2>Content</h2>"
 * formatRTEHtmlValue("<p>Hello</p>") // returns "<p>Hello</p>"
 */
export const formatRTEHtmlValue = (value: string): string =>
  /^<\s*(h[1-6]|p)\s*>\s*<\/\s*\1\s*>$/.test(value) ? EMPTY_CHARACTER : value;
